import { divide, multiply, subtract } from "lodash";
import { getMinValue } from "../PurchaseOrdersComponent";
import FormulaLayout from "./FormulaLayout";

const TdsAmount = ({ bill, gst_charge, tds }) => {
  const finalVal = multiply(
    divide(tds, 100),
    subtract(Number(bill ?? 0), Number(gst_charge ?? 0))
  ).toFixed(2);
  return (
    <FormulaLayout>
      <strong>TDS Amount Formula:</strong>
      <br />
      <br />
      = ( Miller Bill Amount - Miller GST Charge ) * Miller TDS %
      <br />= ( {bill} - {gst_charge} ) * {tds}%
      <br />
      <strong> </strong> = {finalVal}/-
    </FormulaLayout>
  );
};

export default TdsAmount;
